<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">Ajouter une entreprise </h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <form action="page-list-category.html" @submit.prevent="store" data-toggle="validator">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Nom de l'entreprise <span class="text-danger">*</span></label>
                                            <input type="text" v-model="user.name" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Nom <span class="text-danger">*</span></label>
                                            <input type="text" v-model="user.nom" class="form-control" placeholder="" required>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Prenom (s) <span class="text-danger">*</span></label>
                                            <input type="text" v-model="user.prenoms" class="form-control" placeholder="" required>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Contact <span class="text-danger">*</span> </label>
                                                <input type="text" pattern="[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2}" v-model="user.phone" class="form-control" placeholder="" required>                        
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Genre <span class="text-danger">*</span></label>
                                            <select class="form-control" v-model="user.genre" name="" id="" required>
                                                <option  value="MALE"> HOMME </option>
                                                <option  value="FEMALE"> FEMME </option>
                                            </select>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Email <span class="text-danger">*</span></label>
                                            <input type="email" v-model="user.email" class="form-control" placeholder="" required>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Role <span class="text-danger">*</span></label>
                                            <select class="form-control" v-model="user.is_admin" name="" id="" required>
                                                <option  value="1"> ADMIN ENTREPRISE </option>
                                                <option  value="1"> ADMIN SYSTEME </option>
                                            </select>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>                                   
                                </div>          
                                <button type="submit" class="btn btn-primary mr-2">Enregistrer</button>
                                <button type="reset" class="btn btn-danger">reinitialiser</button>
                            </form>
                        </div>
                    </div>
                    <div class="vld-parent">
                        <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data() {
        return {permissions: [],
            user:{},
            isLoading: false,
            fullPage: true
        };
    },
    mounted(){
    },
    methods:{

        store() {
            this.isLoading = true
            axios.post(URL_API+'entreprises', this.user)
            .then(response => {
                
                console.log(response.data)
                this.isLoading = false
                
                if (response.data.status) {
                    Swal.fire(
                        'Succes!',
                        'Utilisateur créé avec succès..',
                        'success'
                    )
                    this.$router.push('/index-entreprises')
                }else{
                    if (response.data.message) {
                            let error =  Object.values(response.data.message)
                        Swal.fire('Error',error[0].toString(),'error')
                    }else{
                        Swal.fire('Error',response.data.error.message,'error')
                    }
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
    }
}
</script>